import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';

import { SFOnDutySF6Api } from '../../shared/sdk/services/custom/SFOnDutySF6';
import { SFOnDutyApi } from '../../shared/sdk/index';



/*
  Generated class for the GetHistoryProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable()
export class GetHistoryProvider {

	constructor(
		public http: HttpClient,
		public SFOnDutyApi: SFOnDutyApi,
		public SFOnDutySF6Api: SFOnDutySF6Api,

	) {
		console.log('Hello GetHistoryProvider Provider');
	}

	/**
	 * attmodule: ONDUTY
	 */
	getHistory(empId: string, skip: number, limit: number, attmodule: string): Observable<any> {
		console.log("GET HISTORY");
		return Observable.create((observer) => {

			let obj;
			switch (attmodule) {
				case 'ATTCOR': obj = this.SFOnDutyApi;
				case 'LEAVE': obj = this.SFOnDutyApi;
				case 'OVERTIME': obj = this.SFOnDutyApi;
				case 'ONDUTY': obj = this.SFOnDutyApi;
				case 'ONDUTY': obj = this.SFOnDutyApi;
			}

			obj.getHistory(empId, skip, limit).subscribe(
				result => {
					observer.next(result);
					observer.complete();
				},
				error => {
					observer.error(error);
				}
			)
		})
	}

}



// WEBPACK FOOTER //
// ./src/providers/get-history/get-history.ts